import { StripeSubscription } from '../api/productService';

export interface SubscriptionStatus {
  isActive: boolean;
  isExpired: boolean;
  isCanceled: boolean;
  expiresAt: Date | null;
  daysUntilExpiration: number | null;
  status: string;
}

/**
 * Get detailed subscription status information
 */
export const getSubscriptionStatus = (subscription: StripeSubscription): SubscriptionStatus => {
  if (!subscription) {
    return {
      isActive: false,
      isExpired: false,
      isCanceled: false,
      expiresAt: null,
      daysUntilExpiration: null,
      status: 'no_subscription'
    };
  }

  const currentPeriodEnd = subscription.current_period_end ||
                           subscription.items.data[0]?.current_period_end;

  const expiresAt = currentPeriodEnd ? new Date(currentPeriodEnd * 1000) : null;
  const now = new Date();

  let isActive = subscription.status === 'active' || subscription.status === 'trialing';
  let isExpired = false;
  let daysUntilExpiration: number | null = null;

  if (expiresAt) {
    const timeDiff = expiresAt.getTime() - now.getTime();
    daysUntilExpiration = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (timeDiff <= 0) {
      isExpired = true;
      isActive = false;
    }
  }

  const isCanceled = subscription.cancel_at_period_end || subscription.status === 'canceled';

  return {
    isActive,
    isExpired,
    isCanceled,
    expiresAt,
    daysUntilExpiration,
    status: subscription.status
  };
};
/**
 * Check if user should be logged out due to subscription status
 */
export const shouldLogoutUser = (subscription: StripeSubscription): boolean => {
  if (!subscription) return true;

  const status = getSubscriptionStatus(subscription);

  // Logout if subscription is expired
  if (status.isExpired) return true;

  // Logout if subscription is not active and not in trial
  if (!status.isActive) return true;

  return false;
};
